import { ToastBaseProps } from "@vintecc/components";

declare global {
  interface Window {
    __RUNTIME_CONFIG__?: ImportMetaEnv;
    companyView?: string | null;
    openToast?: (toast: ToastBaseProps) => void;
  }
}

export const ENV = {
  VERSION: window.__RUNTIME_CONFIG__?.VITE_APP_VERSION ?? import.meta.env.VITE_APP_VERSION,
  AUTH_SERVER: window.__RUNTIME_CONFIG__?.VITE_AUTH_SERVER ?? import.meta.env.VITE_AUTH_SERVER,
  CLIENT_ID: window.__RUNTIME_CONFIG__?.VITE_CLIENT_ID ?? import.meta.env.VITE_CLIENT_ID,
  API_SERVER: window.__RUNTIME_CONFIG__?.VITE_API_SERVER ?? import.meta.env.VITE_API_SERVER,
  AGENTIC_SERVER: window.__RUNTIME_CONFIG__?.VITE_AGENTIC_SERVER ?? import.meta.env.VITE_AGENTIC_SERVER,
  AGENTIC_PREFIX: window.__RUNTIME_CONFIG__?.VITE_AGENTIC_PREFIX ?? import.meta.env.VITE_AGENTIC_PREFIX,
  SSO_DISABLED: (window.__RUNTIME_CONFIG__?.VITE_SSO_DISABLED ?? import.meta.env.VITE_SSO_DISABLED) === "1",
  PROD_URL: window.__RUNTIME_CONFIG__?.VITE_PROD_URL ?? import.meta.env.VITE_PROD_URL,
  MQTT_URL: window.__RUNTIME_CONFIG__?.VITE_MQTT_URL ?? import.meta.env.VITE_MQTT_URL,
  FLIPT_URL: window.__RUNTIME_CONFIG__?.VITE_FLIPT_URL ?? import.meta.env.VITE_FLIPT_URL,
  FLIPT_NAMESPACE: window.__RUNTIME_CONFIG__?.VITE_FLIPT_NAMESPACE ?? import.meta.env.VITE_FLIPT_NAMESPACE,
  FLIPT_CLIENTTOKEN: window.__RUNTIME_CONFIG__?.VITE_FLIPT_CLIENTTOKEN ?? import.meta.env.VITE_FLIPT_CLIENTTOKEN,
  FEATURE_FLAGS_OVERRIDE: window.__RUNTIME_CONFIG__?.VITE_FEATURE_FLAGS_OVERRIDE ?? import.meta.env.VITE_FEATURE_FLAGS_OVERRIDE,
  DEVICE_SYNC_API_ENDPOINT: window.__RUNTIME_CONFIG__?.VITE_DEVICE_SYNC_API_ENDPOINT ?? import.meta.env.VITE_DEVICE_SYNC_API_ENDPOINT,
  SUPPORT_URL: window.__RUNTIME_CONFIG__?.VITE_SUPPORT_URL ?? import.meta.env.VITE_SUPPORT_URL,
  TERMS_AND_CONDITIONS_URL: window.__RUNTIME_CONFIG__?.VITE_TERMS_AND_CONDITIONS_URL ?? import.meta.env.VITE_TERMS_AND_CONDITIONS_URL,
  PRIVACY_POLICY_URL: window.__RUNTIME_CONFIG__?.VITE_PRIVACY_POLICY_URL ?? import.meta.env.VITE_PRIVACY_POLICY_URL,
  DISCLOSURE_URL: window.__RUNTIME_CONFIG__?.VITE_DISCLOSURE_URL ?? import.meta.env.VITE_DISCLOSURE_URL,
  DEBUG_MODAL_ENABLED: window.__RUNTIME_CONFIG__?.VITE_DEBUG_MODAL_ENABLED === "1" || import.meta.env.VITE_DEBUG_MODAL_ENABLED === "1",
  VISUALIZER: window.__RUNTIME_CONFIG__?.VITE_VISUALIZER === "1" || import.meta.env.VITE_VISUALIZER === "1",
  SUPPORTED_LOCALES: window.__RUNTIME_CONFIG__?.VITE_SUPPORTED_LOCALES ?? import.meta.env.VITE_SUPPORTED_LOCALES,
} as const;
